import React from "react";

/**
 * Marks an account the member has retired in QuickBooks.
 *
 * It appears wherever such an account can still be seen — the picker once the
 * toggle is on, and anywhere it is already mapped — because a retired account
 * that looks live invites a member to wonder why they are being asked about it,
 * and one hidden entirely leaves a CertainPath total its own list cannot
 * explain.
 *
 * Neutral by design: this is context, not a problem to fix.
 */
export const InactiveBadge: React.FC = () => (
  <span className="shrink-0 rounded bg-gray-100 px-1.5 py-0.5 text-xs text-gray-600 dark:bg-slate-700 dark:text-gray-300">
    Inactive
  </span>
);
